import React from "react";
import { Link } from "react-router-dom";
import {
  FaLinkedinIn,
  FaTwitter,
  FaInstagram,
  FaWhatsapp,
  FaEnvelope,
  FaPhoneAlt,
  FaClock,
  FaArrowRight,
} from "react-icons/fa";
import "./Footer.css";
import { useLocalContext } from "../../context/LocalContext";
import brandLogo from "../../assets/Digitalcoreweb Gradient Tech Logo.png";

const Footer = () => {
  const { webinfo = {} } = useLocalContext();
  const year = new Date().getFullYear();
  const brandName = webinfo.name || "Digitalcoreweb";

  return (
    <footer className="ft-blue">
      {/* Background Glow */}
      <div className="ft-glow" />

      <div className="ft-wrap">
        <div className="ft-top">
          {/* BRAND COLUMN */}
          <section className="ft-brand">
            <div className="ft-logo">
              <img src={webinfo.logowhite || webinfo.logo || brandLogo} alt={brandName} />
            </div>

            <p className="ft-desc">
              We engineer high-performance web experiences, technical SEO systems,
              and data-driven marketing campaigns that scale brands predictably.
            </p>

            <div className="ft-tags">
              <span>Bespoke Engineering</span>
              <span>Conversion-Focused</span>
              <span>Technical SEO</span>
              <span>Guaranteed ROI</span>
            </div>

            <form
              className="ft-news"
              onSubmit={(e) => {
                e.preventDefault();
                const email = e.target.email.value;
                window.location.href = `mailto:${webinfo.email}?subject=Subscribe to Growth Insights&body=Please add ${email}`;
              }}
            >
              <input
                name="email"
                type="email"
                placeholder="Enter your work email..."
                required
              />
              <button type="submit" className="ft-btn">
                <span>Join</span>
                <FaArrowRight />
              </button>
            </form>
          </section>

          {/* SERVICES NAVIGATION */}
          <nav className="ft-col" aria-label="Footer services navigation">
            <h4>Capabilities</h4>
            <ul>
              <li><Link to="/services">All Services Overview</Link></li>
              <li><Link to="/services/ui-ux-design">UI / UX &amp; Website Design</Link></li>
              <li><Link to="/services/web-development">Website &amp; App Development</Link></li>
              <li><Link to="/services/search-engine-optimization">SEO &amp; Search Visibility</Link></li>
              <li><Link to="/services/social-media-marketing">Social Media Marketing</Link></li>
              <li><Link to="/services/search-engine-marketing">Paid Ads &amp; Lead Gen</Link></li>
              <li><Link to="/services/local-business-growth">Local Business Growth</Link></li>
              <li><Link to="/process">Our 6-Step Process</Link></li>
            </ul>
          </nav>

          {/* COMPANY NAVIGATION */}
          <nav className="ft-col" aria-label="Footer company navigation">
            <h4>Company</h4>
            <ul>
              <li><Link to="/about">About Our Agency</Link></li>
              <li><Link to="/our-strategies">Strategic Framework</Link></li>
              <li><Link to="/contact">Book Consultation</Link></li>
              <li><Link to="/services">Audit &amp; Pricing</Link></li>
            </ul>
          </nav>

          {/* CONTACT & SOCIALS */}
          <section className="ft-contact">
            <h4>Direct Connect</h4>
            <div className="ft-card">
              <div className="ft-row">
                <FaEnvelope className="ft-icon" />
                <div>
                  <span className="ft-k">EMAIL</span>
                  <a className="ft-v" href={`mailto:${webinfo.email}`}>
                    {webinfo.email || "contact@thedigitexy.com"}
                  </a>
                </div>
              </div>

              <div className="ft-row">
                <FaPhoneAlt className="ft-icon" />
                <div>
                  <span className="ft-k">PHONE</span>
                  <a className="ft-v" href={`tel:${webinfo.phonecall}`}>
                    {webinfo.phone || "+91 80000 00000"}
                  </a>
                </div>
              </div>

              <div className="ft-row">
                <FaClock className="ft-icon" />
                <div>
                  <span className="ft-k">HOURS</span>
                  <span className="ft-v">
                    {webinfo.hours || "Mon–Sat · 10am–7pm IST"}
                  </span>
                </div>
              </div>

              <div className="ft-social">
                <a
                  href={webinfo.linkedin || "https://linkedin.com"}
                  target="_blank"
                  rel="noreferrer"
                  aria-label="LinkedIn"
                >
                  <FaLinkedinIn />
                </a>
                <a
                  href={webinfo.twitter || "https://twitter.com"}
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Twitter / X"
                >
                  <FaTwitter />
                </a>
                <a
                  href={webinfo.instagram || "https://instagram.com"}
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Instagram"
                >
                  <FaInstagram />
                </a>
                <a
                  href={webinfo.whatsapp || "https://wa.me/918000000000"}
                  target="_blank"
                  rel="noreferrer"
                  aria-label="WhatsApp"
                >
                  <FaWhatsapp />
                </a>
              </div>
            </div>
          </section>
        </div>

        {/* BOTTOM LEGAL & COPYRIGHT */}
        <div className="ft-bottom">
          <p>© {year} {brandName}. All rights reserved.</p>
          <div className="ft-legal">
            <Link to="/terms-and-conditions">Terms</Link>
            <Link to="/privacy-policy">Privacy</Link>
            <Link to="/refund-policy">Refund Policy</Link>
            <Link to="/shipping-policy">Shipping Policy</Link>
            <Link to="/disclaimer">Disclaimer</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
